let chat_input = document.querySelector("#chat_input");
let chat_session = document.querySelector("#chat_session");
$(document).on("click", "#chat_submit", function () {
  var data = {
    session: chat_session.value, // Receivers phone
    message: chat_input.value, // Message
  };
  $.ajax({
    type: "post",
    url: "https://fewo-easy.local/api.php?api=sendMessage",
    data: JSON.stringify(data),
    xhrFields: {
      withCredentials: false,
    },
    headers: {},
    success: function (data) {
      console.log("Success");
      console.log(data);
      chat_input.value = "";
    },
    error: function () {
      console.log("Die Nachricht konnte leider nicht gesendet werden");
    },
  });
});

$("#chat_input").keypress(function (e) {
  if (e.which == 13) {
    //Enter key pressed
    $("#chat_submit").click(); //Trigger search button click event
  }
});

$(document).on("click", ".chat-start", function () {
  $("#m-chat").modal("show");
  $("#chat-welcome").delay(5000).fadeOut(600);
  var data = {
    session: chat_session.value,
  };
  var loadedMessages = [];
  setInterval(function () {
    $.ajax({
      type: "post",
      url: "https://fewo-easy.local/api.php?api=getMessage",
      data: JSON.stringify(data),
      xhrFields: {
        withCredentials: false,
      },
      headers: {},
      success: function (data) {
        console.log("Success");
        $.each(jQuery.parseJSON(data), function (index, element) {
          if ($.inArray(element.id, loadedMessages) == -1) {
            loadedMessages.push(element.id);
            if (element.sent_by == "customer") element.position = "end";
            else element.position = "start";
            $(".window").append(
              "<div class='d-flex justify-content-" +
                element.position +
                "'> <div class='msg_container'>" +
                element.message +
                " <span class='msg_time'>" +
                element.time +
                "</span></div> </div>"
            );
            $(".modal-body").animate(
              { scrollTop: $(".window").prop("scrollHeight") },
              200
            );
          }
        });
      },
      error: function () {
        console.log("Keine Nachrichten vorhanden");
      },
    });
  }, 2000);
});
